import React, { useEffect } from 'react';
import Tabs from 'antd/lib/tabs';
import queryString from 'query-string';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { AlertsOverview } from './components/AlertsOverview';
import { AlertDetails } from './components/AlertDetails';
import { AlertsPreferences } from './components/AlertsPreferences';

import './AlertsPage.less';

export const AlertsPage = (props) => {
  const { theme, buildingName } = props;
  const { TabPane } = Tabs;
  const history = useHistory();
  const { building } = useParams();
  const { search } = useLocation();
  const { incident_id } = queryString.parse(search);
  const { event_id } = queryString.parse(search);
  const { tab } = queryString.parse(search);

  useEffect(() => {
    if (!tab && !incident_id && !event_id) {
      history.replace(`/alerts/${building}?tab=Overview`);
    }
  }, [search]);

  if (incident_id && event_id) {
    return <AlertDetails theme={theme} buildingName={buildingName} />;
  }

  const changeTab = (activeKey) => {
    history.push(`/alerts/${building}?tab=${activeKey}`);
  };

  const getDefaultActiveKey = () => {
    return tab;
  };

  return (
    <div id="alerts-page">
      <div className="alerts-page-header">
        <div className="alerts-page-title">Alerts</div>
        <Tabs
          className={`alerts-tabs app-tabs-${theme}`}
          defaultActiveKey={getDefaultActiveKey()}
          onChange={(activeKey) => changeTab(activeKey)}
        >
          <TabPane tab="Overview" key="Overview">
            <AlertsOverview theme={theme} buildingName={buildingName} />
          </TabPane>
          <TabPane tab="Preferences" key="Preferences">
            <AlertsPreferences theme={theme} buildingName={buildingName} />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
